import { t } from 'i18next';
import { Component, type PropsWithChildren } from 'react';
import type { WrappedNotificationHandlerContract } from '../types/handlers/notification';
import { SparkSuspense } from './spark-suspense';

type ErrorBoundaryProps = PropsWithChildren<{
  notificationHandler: WrappedNotificationHandlerContract;
}>;

type ErrorBoundaryState = {
  error: Error | null;
};

export class ErrorBoundaryFallback extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch() {
    this.props.notificationHandler.error();
  }

  render() {
    return (
      <SparkSuspense
        isError={this.state.error !== null}
        isLoading={false}
        errorMessage={t('errors:generic')}
        onReload={() => window.location.reload()}
      >
        {this.props.children}
      </SparkSuspense>
    );
  }
}
